// Self-contained data for the Kaye Arellano real-estate concept website.
export const AGENT = {
  "slug": "kaye-arellano-real-estate-concept",
  "name": "Kaye Arellano",
  "shortName": "Kaye",
  "role": "Licensed Real Estate Broker",
  "location": "Makati City, BGC & central Metro Manila",
  "theme": "relocation",
  "media": {
    "hero": {
      "src": "/realestate/kaye-arellano/capture-072944.webp",
      "thumbnail": "/realestate/kaye-arellano/capture-072944-720.webp",
      "alt": "Landscaped Makati park framed by the city skyline",
      "label": "A calmer way to move through Manila",
      "type": "property"
    },
    "profile": {
      "src": "/realestate/kaye-arellano/profile.webp",
      "thumbnail": "/realestate/kaye-arellano/profile-720.webp",
      "alt": "Professional portrait of Kaye Arellano",
      "label": "Kaye Arellano",
      "type": "portrait"
    },
    "gallery": [
      {
        "src": "/realestate/kaye-arellano/profile-2.webp",
        "thumbnail": "/realestate/kaye-arellano/profile-2-720.webp",
        "alt": "Alternate portrait of Kaye Arellano",
        "label": "Responsive, personal guidance",
        "type": "portrait"
      },
      {
        "src": "/realestate/kaye-arellano/capture-072909.webp",
        "thumbnail": "/realestate/kaye-arellano/capture-072909-720.webp",
        "alt": "Spacious premium condominium interior",
        "label": "Space to settle in",
        "type": "property"
      },
      {
        "src": "/realestate/kaye-arellano/capture-073001.webp",
        "thumbnail": "/realestate/kaye-arellano/capture-073001-720.webp",
        "alt": "Second skyline view over a landscaped urban park",
        "label": "City access with room to breathe",
        "type": "property"
      },
      {
        "src": "/realestate/kaye-arellano/capture-073110.webp",
        "thumbnail": "/realestate/kaye-arellano/capture-073110-720.webp",
        "alt": "Bright furnished condominium bedroom",
        "label": "Corporate-ready comfort",
        "type": "property"
      },
      {
        "src": "/realestate/kaye-arellano/capture-073205.webp",
        "thumbnail": "/realestate/kaye-arellano/capture-073205-720.webp",
        "alt": "Large residence with timber flooring",
        "label": "Premium homes with flexible potential",
        "type": "property"
      },
      {
        "src": "/realestate/kaye-arellano/capture-073228.webp",
        "thumbnail": "/realestate/kaye-arellano/capture-073228-720.webp",
        "alt": "Modern white residential kitchen",
        "label": "Practical details checked",
        "type": "property"
      },
      {
        "src": "/realestate/kaye-arellano/capture-073310.webp",
        "thumbnail": "/realestate/kaye-arellano/capture-073310-720.webp",
        "alt": "Furnished open-plan living and dining room",
        "label": "Move-in-ready Manila living",
        "type": "property"
      }
    ]
  },
  "accent": "#C6523F",
  "ink": "#17324D",
  "paper": "#F4F7F8",
  "eyebrow": "Responsive Manila relocation",
  "headline": "A calm, capable guide for a fast-moving Manila lease.",
  "intro": "Premium condominium leasing for professionals, international residents and corporate teams who need careful listening, quick answers and dependable coordination.",
  "promise": "Your requirements heard. Your move kept on track.",
  "proof": [
    "8 Rentpad reviews",
    "8 five-star ratings",
    "Rentpad member since 2023",
    "Active Makati & BGC inventory"
  ],
  "audiences": [
    "Corporate relocations",
    "International residents",
    "Makati condo renters",
    "BGC professionals"
  ],
  "services": [
    {
      "title": "Makati leasing",
      "text": "A substantial public portfolio in Salcedo Village, Legazpi Village, Rockwell and premium central Makati buildings."
    },
    {
      "title": "BGC residences",
      "text": "One- to three-bedroom options across Fort Bonifacio, including premium and corporate-ready homes."
    },
    {
      "title": "Corporate requirements",
      "text": "Viewings and property coordination adapted to foreign staff, company requests and short relocation timelines."
    },
    {
      "title": "Terms & move-in",
      "text": "Responsive communication, flexible-term negotiation where possible and support beyond lease signing."
    }
  ],
  "process": [
    "Capture the brief and moving timeline",
    "Curate a practical viewing itinerary",
    "Resolve questions and negotiate terms",
    "Coordinate signing, requirements and move-in"
  ],
  "about": "Kaye’s public rental activity is concentrated in premium Makati and BGC residences. Her reviews consistently emphasize responsiveness, attention to specific requirements, calm professionalism and continued availability after the lease is signed—particularly valuable for corporate and international moves.",
  "contact": {},
  "profiles": [
    {
      "label": "Rentpad profile",
      "href": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71",
      "imageSource": true
    },
    {
      "label": "Dot Property listings",
      "href": "https://www.dotproperty.com.ph/publisher/kaye-arellano_77acaf1c6248-6cef-d3c5-e581-0b32e102/properties-for-rent",
      "imageSource": true
    }
  ],
  "websiteAssessment": "Highest-priority website gap: no dedicated business website surfaced in search; the visible presence consists mainly of marketplace profile and listing pages.",
  "reviewRating": 5,
  "reviewCount": 8,
  "reviews": [
    {
      "author": "Michael Kerin",
      "stars": 5,
      "summary": "Describes a highly responsive, timely and reliable professional who made securing a condo lease a positive experience.",
      "source": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71"
    },
    {
      "author": "Blaine",
      "stars": 5,
      "summary": "Says Kaye made a stressful condo search smooth by staying responsive and prioritizing the client’s needs.",
      "source": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71"
    },
    {
      "author": "Ejay Lemoncito",
      "stars": 5,
      "summary": "Reports securing the desired home and adding Kaye to a very short list of trusted long-term brokers.",
      "source": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71"
    },
    {
      "author": "Surendran S Ravi",
      "stars": 5,
      "summary": "Highlights immediate answers, professionalism and sound guidance.",
      "source": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71"
    },
    {
      "author": "Safuriyawu Ahmed",
      "stars": 5,
      "summary": "Credits her with understanding requirements, negotiating flexible terms and supporting a very short move-in schedule.",
      "source": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71"
    },
    {
      "author": "Marrion Castaneda",
      "stars": 5,
      "summary": "Submitted a five-star rating without written feedback.",
      "source": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71"
    },
    {
      "author": "Quinn Asuncion",
      "stars": 5,
      "summary": "Says she was responsive and accommodating when arranging Makati options for a foreign staff member.",
      "source": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71"
    },
    {
      "author": "Patrick Bramucciriopelle",
      "stars": 5,
      "summary": "Describes her as responsive, kind, helpful, trustworthy and available after move-in.",
      "source": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71"
    }
  ],
  "sources": [
    {
      "label": "Rentpad",
      "href": "https://rentpad.com.ph/user/kaye-arellano/fe4d381c71",
      "note": "Active inventory, rating and all eight review records"
    },
    {
      "label": "Dot Property",
      "href": "https://www.dotproperty.com.ph/publisher/kaye-arellano_77acaf1c6248-6cef-d3c5-e581-0b32e102/properties-for-rent",
      "note": "Licensed-broker label and additional public listings"
    }
  ]
};
